export default {
    userInfo: {},
    isActive_Bottom: true,
    isActive: true,
    isActive0: false
}
